const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.02,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.14,
    y: 390.92,
    width: 43.55,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 389.21,
    width: 48.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.61,
    y: 392.59,
    width: 34.29,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.46,
    y: 392.59,
    width: 7.44,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.8,
    y: 392.59,
    width: 48.57,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.62,
    y: 396.81,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.65,344.37c19.94-12.12,29.1-24,53.53-6.18,23.23,17,82.82,44.21,82.82,44.21H47S93.7,356.5,113.65,344.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.65,344.37c12.62-7.68,20.93-15.26,31.52-15.26-2.26,3.6-21.92,14.52-22.06,22-.15,8.58,13.81,20,6.19,31.28H47S93.7,356.5,113.65,344.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.49,327c-37.54-17.67-54.78-35-100.75-9C203,342.73,90.88,382.4,90.88,382.4h382S385,344.67,347.49,327Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.48,327c-23.76-11.19-39.39-22.23-59.32-22.24,4.26,5.25,41.26,21.16,41.51,32.07.29,12.5-26,29.14-11.65,45.57H472.91S385,344.67,347.48,327Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.55,297l.49.4c1.67-6.05,6.27-7.66,8.74-3.81l.1-.43c0-.19.2-.31.34-.26a.33.33,0,0,1,.19.42l-.22,1a13.88,13.88,0,0,1,1.21,5.61,38.15,38.15,0,0,0,3.57,15c.06-2.11.13-4.2.19-6.26l-.38-1a.41.41,0,0,1,.14-.47.23.23,0,0,1,.29,0c.09-2.79.18-5.53.26-8.18l-.62-1.12a.41.41,0,0,1,.07-.49.24.24,0,0,1,.39.06l.2.37c.15-4.6.3-9,.44-13l-.93-1a.4.4,0,0,1,0-.49.24.24,0,0,1,.39-.06l.59.62c.09-2.46.18-4.81.26-7l-.78-1.19a.41.41,0,0,1,0-.49.24.24,0,0,1,.39,0l.39.59c.28-7.34.54-13.16.77-16.88a14.7,14.7,0,0,1,3.15-9l-.57-.66a.4.4,0,0,1,0-.49.24.24,0,0,1,.39,0l.61.71a5.9,5.9,0,0,1,4.13-1.93,6.41,6.41,0,0,1,4.88,1.77l.13-.27a.26.26,0,0,1,.38-.14.4.4,0,0,1,.09.48l-.2.4c1.36,1.71,2.32,4.63,2.6,9.53.15,2.6.08,8-.15,15.35l.31-.44a.24.24,0,0,1,.4,0,.42.42,0,0,1,0,.49l-.75,1.07c-.09,2.77-.2,5.8-.33,9.05.84-.87,1.75-1.89,2.68-3.05l.06-1.46a.34.34,0,0,1,.29-.36c.16,0,.27.16.27.36l0,.71a44,44,0,0,0,4.46-7.13l-.57-.87a.42.42,0,0,1,.05-.49.23.23,0,0,1,.39,0l.45.68a44.37,44.37,0,0,0,4-13.23,15.52,15.52,0,0,1,1.84-5.81l-.49-1.78a.42.42,0,0,1,.18-.46.26.26,0,0,1,.35.2l.38,1.4c1.56-2.2,3.6-2.89,5.41-2.25l.26-.7c.07-.18.23-.27.37-.19a.37.37,0,0,1,.13.46l-.25.65c2.55,1.31,4.45,5.4,3.44,11.79,0,.21-.07.42-.11.62l.07-.05a.23.23,0,0,1,.38.09.42.42,0,0,1-.09.49l-.52.42a74.35,74.35,0,0,1-4,14.58l.1-.07a.25.25,0,0,1,.37.15.42.42,0,0,1-.14.48l-.77.48c-3,7-7.46,13.35-14.11,16.47a.38.38,0,0,1,0,.21.32.32,0,0,1-.28.27h-.07l-.42-.13a21.25,21.25,0,0,1-4.61,1.36c-.12,2.83-.26,5.76-.4,8.77l.07-.06a.24.24,0,0,1,.38.1.44.44,0,0,1-.1.49l-.39.31c-.26,5.48-.54,11.22-.83,17.11l.35-.49a.24.24,0,0,1,.39-.05.42.42,0,0,1,0,.5l-.8,1.15c-.61,12.27-1.28,25.16-1.92,37.77l.36-.59a.26.26,0,0,1,.4-.08.43.43,0,0,1,0,.5l-.85,1.37c-.3,5.75-.59,11.44-.87,17H172c.07-2.33.14-4.69.21-7l-.41-.41a.4.4,0,0,1,0-.49.24.24,0,0,1,.39-.07l.09.08c.33-11.23.67-22.74,1-34h0c.06-2.17.12-4.34.19-6.48h0c-7.72-4.11-11.58-13.26-13.13-22.07l-.8-.66a.41.41,0,0,1-.06-.49.25.25,0,0,1,.38-.11l.31.26a58.45,58.45,0,0,1-.69-8.26,20.17,20.17,0,0,1,.46-4.55l-.63-.52a.39.39,0,0,1-.07-.48A.25.25,0,0,1,159.55,297Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.12,339.8c0-.19.17-.3.32-.25l.3.09c-.12-4.2,2.56-5.9,4.49-3.68l.82-.54a.24.24,0,0,1,.36.14.37.37,0,0,1-.1.46l-.7.46a8.16,8.16,0,0,1,1.05,2.6,22,22,0,0,0,.86,2.74l.05-.17a.25.25,0,0,1,.35-.18.39.39,0,0,1,.15.45l-.22.72a21.15,21.15,0,0,0,3.42,5.5l0-.79c0-.19.13-.33.28-.31a.33.33,0,0,1,.25.36l-.06,1.31a19.71,19.71,0,0,0,2.43,2.24c-.3-3.14-.62-6.21-.94-9.18l-.83-.7a.41.41,0,0,1-.08-.47.23.23,0,0,1,.37-.09l.44.37c-.31-2.88-.61-5.65-.9-8.28l-.5-.54a.39.39,0,0,1,0-.47.22.22,0,0,1,.37,0l.06.06c-.13-1.12-.25-2.22-.36-3.27,0-.19-.05-.37-.07-.55-7.82-1.92-11-11.49-11.67-18.09,0-.45-.06-.87-.06-1.28h0a.28.28,0,0,1-.24-.18.39.39,0,0,1,.11-.46l.19-.13c.45-5.38,5.2-5.79,6,.49a22.35,22.35,0,0,0,1.15,4.8.22.22,0,0,1,.26-.11.36.36,0,0,1,.2.41l-.11.62a22.69,22.69,0,0,0,3.33,5.64,67.32,67.32,0,0,1-.49-8.73l-.34-.34A.39.39,0,0,1,410,310a.23.23,0,0,1,.37-.06l.1.1c.35-2.87,1.15-4.5,2.21-5.39a.25.25,0,0,1-.15-.08l-.7-.75a.41.41,0,0,1,0-.48.22.22,0,0,1,.37,0l.7.75a.4.4,0,0,1,.08.38,5.18,5.18,0,0,1,3.05-.81,5.37,5.37,0,0,1,3.48,1.61l.27-.63a.23.23,0,0,1,.36-.13.39.39,0,0,1,.11.46l-.31.73a7.63,7.63,0,0,1,2.1,5c0,1.06.1,2.41.18,4a.27.27,0,0,1,.18.08.42.42,0,0,1,0,.48l-.18.29c.07,1.52.16,3.25.26,5.15a.23.23,0,0,1,.36,0,.42.42,0,0,1,0,.48l-.35.55c.17,3.17.36,6.77.59,10.7a15.35,15.35,0,0,0,1.69-2.52l-.27-.35a.41.41,0,0,1,0-.48.22.22,0,0,1,.37,0l.2.24c.14-.3.29-.61.43-.93,1.4-3.37,3.63-3.29,4.71-1.42l.29-.44a.23.23,0,0,1,.38,0,.41.41,0,0,1,0,.48l-.41.61a7.3,7.3,0,0,1-.27,5c-1.23,3.24-3.48,7-6.63,8.94h0c0,.73.09,1.47.13,2.21h0c.15,2.62.31,5.32.48,8.07a.22.22,0,0,1,.29.1.4.4,0,0,1,0,.48l-.22.24c.39,6.59.82,13.47,1.25,20.32l.14-.12a.24.24,0,0,1,.38.09.4.4,0,0,1-.07.47l-.4.35c.19,2.92.38,5.83.57,8.71h-9.81c-.18-7.2-.68-14.83-1.31-22.34h0c-.06-.76-.12-1.53-.19-2.29a10.22,10.22,0,0,1-3.12-.58l-.49.77a.25.25,0,0,1-.21.12.23.23,0,0,1-.17-.07.42.42,0,0,1,0-.48l.35-.55c-4.59-1.91-7.56-6.93-9.18-11.68a.25.25,0,0,1-.14.06.24.24,0,0,1-.15-.06.41.41,0,0,1-.08-.47l.13-.27c-.31-1-.56-1.95-.75-2.86a12.21,12.21,0,0,1-.21-1.36l-.46-.13A.36.36,0,0,1,400.12,339.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.81,
    cy: 121.23,
    r: 19.33,
    transform: "translate(-37.26 195.38) rotate(-76.72)",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-7",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cacti--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.53,237.59c-2,17.21-12.2,28.85-19.65,35.22-.12-17.8-.45-30.95-1.13-36.17-1.84-14.21-8.06-16.7-15.15-16.7h0c-7.27,0-13.12,7.28-13,16.15-.28,12.8.12,43.16.75,79.52a47.72,47.72,0,0,1-7.65-21.31c-1.85-18-20.86-14.74-19.6,3.9,1,15.19,8.28,36.52,27.74,44.49.42,22.58.88,46.26,1.29,68.72h26c.3-39.39.78-84.21.79-118.92,28.75-4,38.13-31.49,40.82-50.19C418.64,222.22,396.83,218.06,394.53,237.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.53,237.59c-2,17.21-12.2,28.85-19.65,35.22-.12-17.8-.45-30.95-1.13-36.17-1.84-14.21-8.06-16.7-15.15-16.7h0c-7.27,0-13.12,7.28-13,16.15-.28,12.8.12,43.16.75,79.52a47.72,47.72,0,0,1-7.65-21.31c-1.85-18-20.86-14.74-19.6,3.9,1,15.19,8.28,36.52,27.74,44.49.42,22.58.88,46.26,1.29,68.72h26c.3-39.39.78-84.21.79-118.92,28.75-4,38.13-31.49,40.82-50.19C418.64,222.22,396.83,218.06,394.53,237.59Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.32,292.35c1.36,2.85,5,5.33,6.6,6.35q0-3.17,0-6.21A39.73,39.73,0,0,1,368.32,292.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.84,342.69q.09,4.57.18,9.21c1.21-1.18,6-5.72,7.53-9A16.45,16.45,0,0,1,346.84,342.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.92,236.58a.51.51,0,0,1-.31-.11l-2.27-1.81a.52.52,0,0,1-.08-.71.51.51,0,0,1,.71-.07l2.26,1.81a.49.49,0,0,1,.08.7A.52.52,0,0,1,348.92,236.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,224.87a.53.53,0,0,1-.24-.06.5.5,0,0,1-.19-.68l1.16-2.07a.5.5,0,1,1,.87.49l-1.16,2.07A.5.5,0,0,1,367,224.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.45,234.18A.49.49,0,0,1,357,234l-1-1.49a.49.49,0,0,1,.14-.69.5.5,0,0,1,.69.14l1,1.49a.5.5,0,0,1-.14.69A.48.48,0,0,1,357.45,234.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.31,223.84a.48.48,0,0,1-.33-.13l-1.48-1.29a.5.5,0,0,1,.65-.75l1.49,1.29a.51.51,0,0,1,.05.71A.52.52,0,0,1,351.31,223.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.19,243.82a.51.51,0,0,1-.32-.12.49.49,0,0,1-.06-.7l1.36-1.62a.5.5,0,0,1,.76.64l-1.35,1.62A.5.5,0,0,1,370.19,243.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,255.65a.5.5,0,0,1-.29-.09l-1.36-1a.5.5,0,0,1-.12-.7.51.51,0,0,1,.7-.11l1.36,1a.5.5,0,0,1,.11.69A.48.48,0,0,1,358,255.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,246a.49.49,0,0,1-.3-.1l-1.94-1.49a.5.5,0,1,1,.61-.79l1.94,1.49a.5.5,0,0,1-.31.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.59,262.44a.49.49,0,0,1-.37-.16l-2.14-2.4a.5.5,0,0,1,0-.7.5.5,0,0,1,.71,0l2.13,2.39a.49.49,0,0,1-.37.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.43,261.25a.47.47,0,0,1-.32-.12.5.5,0,0,1-.07-.7l2.2-2.62a.5.5,0,1,1,.77.64l-2.2,2.62A.49.49,0,0,1,373.43,261.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.25,235a.45.45,0,0,1-.31-.11.49.49,0,0,1-.07-.7l1.29-1.59a.5.5,0,0,1,.7-.07.5.5,0,0,1,.07.71l-1.29,1.58A.5.5,0,0,1,368.25,235Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,269.1a.5.5,0,0,1-.5-.5v-2.2a.5.5,0,0,1,.5-.5.51.51,0,0,1,.5.5v2.2A.5.5,0,0,1,380,269.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.33,258.63a.51.51,0,0,1-.37-.17l-2.13-2.39a.5.5,0,0,1,0-.71.5.5,0,0,1,.7,0l2.14,2.39a.51.51,0,0,1,0,.71A.5.5,0,0,1,389.33,258.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.13,235a.45.45,0,0,1-.25-.07.5.5,0,0,1-.19-.68L412,232a.5.5,0,0,1,.68-.19.5.5,0,0,1,.18.68l-1.29,2.27A.5.5,0,0,1,411.13,235Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.19,230.5a.51.51,0,0,1-.46-.31l-1.36-3.37a.5.5,0,0,1,.93-.37l1.36,3.36a.5.5,0,0,1-.28.65A.41.41,0,0,1,398.19,230.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.57,227.26a.63.63,0,0,1-.19,0,.5.5,0,0,1-.27-.66l1-2.33a.49.49,0,0,1,.65-.26.49.49,0,0,1,.27.65L408,227A.49.49,0,0,1,407.57,227.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3,253.52a.52.52,0,0,1-.41-.21.5.5,0,0,1,.13-.7l2.13-1.49a.5.5,0,1,1,.57.82l-2.13,1.49A.52.52,0,0,1,403.3,253.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.45,243.37a.49.49,0,0,1-.46-.32l-.65-1.61a.5.5,0,0,1,.93-.38l.65,1.62a.51.51,0,0,1-.28.65A.43.43,0,0,1,398.45,243.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.06,266.9a.48.48,0,0,1-.45-.27.49.49,0,0,1,.22-.67l1.65-.84a.49.49,0,0,1,.67.22.5.5,0,0,1-.22.67l-1.65.84A.44.44,0,0,1,408.06,266.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.79,276.93a.5.5,0,0,1-.12-1l1.74-.45a.5.5,0,1,1,.25,1l-1.74.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.05,269.36a.5.5,0,0,1-.06-1l2.13-.26a.5.5,0,1,1,.12,1l-2.13.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,290.75h-.12l-2.64-.63a.52.52,0,0,1-.37-.61.51.51,0,0,1,.61-.37l2.64.64a.5.5,0,0,1,.37.6A.5.5,0,0,1,384,290.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.47,282.94a.49.49,0,0,1-.45-.7l1.16-2.59a.51.51,0,0,1,.66-.25.5.5,0,0,1,.26.66l-1.17,2.59A.5.5,0,0,1,380.47,282.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.23,245.21a.49.49,0,0,1-.41-.22.5.5,0,0,1,.13-.7l1.78-1.19a.5.5,0,1,1,.56.83l-1.78,1.19A.49.49,0,0,1,414.23,245.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399,262.12a.51.51,0,0,1-.5-.49l-.06-3.23a.49.49,0,0,1,.49-.51.5.5,0,0,1,.51.49l.06,3.23a.5.5,0,0,1-.49.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.07,273a.52.52,0,0,1-.31-.1L344,271.45a.5.5,0,0,1-.08-.7.49.49,0,0,1,.7-.08l1.81,1.42a.5.5,0,0,1-.31.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,278.41a.49.49,0,0,1-.37-.16l-2-2.26a.5.5,0,0,1,0-.71.49.49,0,0,1,.7,0l2,2.26a.49.49,0,0,1-.37.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.44,269.23a.5.5,0,0,1-.24-.06.5.5,0,0,1-.2-.68l1.29-2.33a.5.5,0,0,1,.88.49L364.88,269A.52.52,0,0,1,364.44,269.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.3,294.39a.51.51,0,0,1-.4-.2l-2.13-2.78a.5.5,0,1,1,.79-.61l2.14,2.78a.49.49,0,0,1-.09.7A.51.51,0,0,1,347.3,294.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,290.44a.51.51,0,0,1-.31-.11.5.5,0,0,1-.09-.7l1.1-1.42a.5.5,0,0,1,.7-.08.49.49,0,0,1,.09.7l-1.1,1.41A.49.49,0,0,1,352,290.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.62,290.44a.52.52,0,0,1-.41-.22.5.5,0,0,1,.13-.69l1.67-1.16a.51.51,0,0,1,.7.12.5.5,0,0,1-.13.7l-1.67,1.16A.52.52,0,0,1,371.62,290.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.46,307.64a.52.52,0,0,1-.42-.22.49.49,0,0,1,.15-.69l2.84-1.88a.5.5,0,0,1,.69.14.51.51,0,0,1-.14.7l-2.84,1.87A.48.48,0,0,1,372.46,307.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.78,307.26a.5.5,0,0,1-.44-.27l-.9-1.75a.5.5,0,1,1,.88-.46l.91,1.75a.49.49,0,0,1-.22.67A.46.46,0,0,1,346.78,307.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.64,309.2a.48.48,0,0,1-.36-.16l-2-2.07a.49.49,0,0,1,0-.7.5.5,0,0,1,.71,0l2,2.07a.5.5,0,0,1,0,.71A.52.52,0,0,1,355.64,309.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,303.63a.42.42,0,0,1-.22-.05.48.48,0,0,1-.23-.66l1.35-2.79a.51.51,0,0,1,.67-.23.51.51,0,0,1,.23.67l-1.36,2.78A.48.48,0,0,1,363,303.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.14,288.63H335a.49.49,0,0,1-.37-.6l.77-3.3a.5.5,0,0,1,1,.23l-.78,3.3A.49.49,0,0,1,335.14,288.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.69,293a.5.5,0,0,1-.26-.08l-3-1.91a.5.5,0,1,1,.53-.84l3,1.9a.51.51,0,0,1,.16.69A.52.52,0,0,1,321.69,293Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.86,312.17a.47.47,0,0,1-.27-.08l-2.68-1.68a.49.49,0,0,1-.16-.69.5.5,0,0,1,.69-.15l2.68,1.68a.5.5,0,0,1-.26.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.36,310.88h0a.51.51,0,0,1-.47-.53l.13-2.26a.5.5,0,0,1,1,.05l-.13,2.27A.51.51,0,0,1,330.36,310.88Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.8,319.28a.5.5,0,0,1-.5-.5v-2.26a.5.5,0,0,1,1,0v2.26A.5.5,0,0,1,339.8,319.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.37,329.5h-.09l-2.72-.51a.5.5,0,0,1,.19-1l2.72.52a.48.48,0,0,1,.39.58A.49.49,0,0,1,336.37,329.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.63,300.27h-.09a.5.5,0,0,1-.41-.57l.39-2.2a.5.5,0,0,1,.58-.41.51.51,0,0,1,.41.58l-.39,2.2A.49.49,0,0,1,334.63,300.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.25,323.1A.47.47,0,0,1,366,323a.49.49,0,0,1-.13-.69l1.68-2.46a.5.5,0,1,1,.82.56l-1.68,2.46A.5.5,0,0,1,366.25,323.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.49,333.25a.54.54,0,0,1-.32-.11.51.51,0,0,1-.06-.71l2.26-2.71a.49.49,0,0,1,.7-.07.5.5,0,0,1,.07.71l-2.26,2.71A.51.51,0,0,1,373.49,333.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,340a.5.5,0,0,1-.32-.11.51.51,0,0,1-.06-.71l2.26-2.71a.52.52,0,0,1,.71-.07.51.51,0,0,1,.06.71l-2.26,2.71A.5.5,0,0,1,364,340Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.79,330.34a.5.5,0,0,1-.46-.3l-1.09-2.52a.5.5,0,1,1,.91-.4l1.1,2.52a.5.5,0,0,1-.26.66A.51.51,0,0,1,350.79,330.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,358.15a.5.5,0,0,1-.35-.15L352,356.77a.5.5,0,0,1,0-.7.5.5,0,0,1,.71,0l1.23,1.22a.51.51,0,0,1,0,.71A.51.51,0,0,1,353.57,358.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.64,357.05a.54.54,0,0,1-.22-.05.5.5,0,0,1-.24-.66l1.17-2.46a.49.49,0,0,1,.66-.24.5.5,0,0,1,.24.67l-1.16,2.45A.51.51,0,0,1,366.64,357.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,370.43a.47.47,0,0,1-.37-.16l-1.27-1.43a.49.49,0,0,1,.05-.7.48.48,0,0,1,.7,0l1.26,1.42a.49.49,0,0,1-.37.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,372.31a.5.5,0,0,1-.24-.06.51.51,0,0,1-.2-.68L371,369a.5.5,0,0,1,.88.48l-1.42,2.59A.49.49,0,0,1,370,372.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.43,383.76a.51.51,0,0,1-.4-.2l-1.29-1.68a.5.5,0,0,1,.79-.61l1.3,1.68a.51.51,0,0,1-.1.7A.48.48,0,0,1,360.43,383.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.75,387.76a.55.55,0,0,1-.3-.09.5.5,0,0,1-.1-.7l1.61-2.2a.51.51,0,0,1,.7-.11.5.5,0,0,1,.11.7l-1.62,2.2A.51.51,0,0,1,373.75,387.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.12,389.32a.49.49,0,0,1-.34-.14l-2.46-2.26a.5.5,0,1,1,.68-.73l2.46,2.26a.5.5,0,0,1-.34.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.16,394.69a.36.36,0,0,1-.17,0,.49.49,0,0,1-.29-.64l.72-2a.5.5,0,0,1,.94.34l-.73,2A.49.49,0,0,1,361.16,394.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.67,402.54a.53.53,0,0,1-.29-.1l-2.21-1.61a.5.5,0,0,1,.59-.81l2.21,1.61a.51.51,0,0,1,.11.7A.52.52,0,0,1,349.67,402.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.81,397.79a.5.5,0,0,1-.24-.06.51.51,0,0,1-.19-.69l1.66-2.9a.5.5,0,0,1,.87.5l-1.66,2.9A.5.5,0,0,1,369.81,397.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,331.7a23.36,23.36,0,0,1-4.69,5.95c-.67-14.6-1.13-26.17-1.27-32,.1-5.39-5.86-10.39-11-10.39s-9.4,1.5-10.72,10.13c-.34,2.25-.08,6.92.54,13.32A29.48,29.48,0,0,1,105.27,302C103.86,291.66,93,293.6,94,304.27c1,9.72,6.59,23.82,21.17,26.65,1.12,9.85,2.54,21.66,3.78,34.15-4.45-2.78-11.1-8.29-13.7-17.51-2.84-10.11-13.27-6.65-10.7,3.86,2.39,9.74,10.11,23.33,25.33,23.69,1,12.16,1.83,24.62,1.91,36.3h18.35c-1.17-20.35-2.3-41.8-3.2-60.29,6-2.92,10.33-8.4,12.75-13.17C154.15,329.25,145.6,323.43,141,331.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,331.7a23.36,23.36,0,0,1-4.69,5.95c-.67-14.6-1.13-26.17-1.27-32,.1-5.39-5.86-10.39-11-10.39s-9.4,1.5-10.72,10.13c-.34,2.25-.08,6.92.54,13.32A29.48,29.48,0,0,1,105.27,302C103.86,291.66,93,293.6,94,304.27c1,9.72,6.59,23.82,21.17,26.65,1.12,9.85,2.54,21.66,3.78,34.15-4.45-2.78-11.1-8.29-13.7-17.51-2.84-10.11-13.27-6.65-10.7,3.86,2.39,9.74,10.11,23.33,25.33,23.69,1,12.16,1.83,24.62,1.91,36.3h18.35c-1.17-20.35-2.3-41.8-3.2-60.29,6-2.92,10.33-8.4,12.75-13.17C154.15,329.25,145.6,323.43,141,331.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,330.92c.12,1,.23,2,.36,3a28.4,28.4,0,0,0,5.21-3.49A12.8,12.8,0,0,1,115.2,330.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,351.12a12.31,12.31,0,0,1-5.44.21s3.59,2.55,5.6,3C137.09,353.28,137,352.19,137,351.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.19,378.49c1.7-.61,4.81-4.34,5-4.58a13.76,13.76,0,0,1-5.29,1.2C120,376.23,120.1,377.36,120.19,378.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.93,307a.51.51,0,0,1-.31-.11l-1.94-1.56a.5.5,0,1,1,.62-.78l2,1.56a.5.5,0,0,1-.32.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.49,299.23a.57.57,0,0,1-.25-.06.51.51,0,0,1-.19-.68l1-1.78a.5.5,0,0,1,.88.49l-1,1.78A.52.52,0,0,1,130.49,299.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.15,305.67a.5.5,0,0,1-.42-.22l-.84-1.28a.5.5,0,0,1,.84-.55l.83,1.28a.5.5,0,0,1-.14.69A.47.47,0,0,1,123.15,305.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.87,296.78a.5.5,0,0,1-.33-.12l-1.28-1.11a.5.5,0,1,1,.66-.75l1.28,1.11a.49.49,0,0,1,0,.7A.45.45,0,0,1,117.87,296.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.09,314a.5.5,0,0,1-.38-.82l1.16-1.39a.51.51,0,0,1,.71-.06.49.49,0,0,1,.06.7l-1.17,1.39A.49.49,0,0,1,134.09,314Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,324.12a.46.46,0,0,1-.29-.1l-1.16-.83a.5.5,0,0,1-.12-.7.51.51,0,0,1,.7-.11l1.17.83a.51.51,0,0,1,.11.7A.52.52,0,0,1,123.64,324.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.81,315.78a.49.49,0,0,1-.3-.1l-1.67-1.28a.5.5,0,1,1,.61-.79l1.67,1.28a.5.5,0,0,1-.31.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89,344.45a.5.5,0,0,1-.44-.27.49.49,0,0,1,.21-.67l2.62-1.34a.5.5,0,0,1,.67.21.5.5,0,0,1-.22.68l-2.61,1.34A.59.59,0,0,1,101.89,344.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.42,306.4a.47.47,0,0,1-.31-.12.49.49,0,0,1-.07-.7l1.11-1.36a.49.49,0,0,1,.7-.07.49.49,0,0,1,.07.7l-1.11,1.36A.51.51,0,0,1,132.42,306.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.62,353.79a.48.48,0,0,1-.2,0,.49.49,0,0,1-.26-.65l.73-1.74a.5.5,0,1,1,.92.39l-.73,1.74A.5.5,0,0,1,106.62,353.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.65,312.15a.45.45,0,0,1-.25-.07L97,310.67a.49.49,0,0,1-.18-.68.51.51,0,0,1,.69-.18l2.37,1.41a.51.51,0,0,1,.17.69A.49.49,0,0,1,99.65,312.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.73,390.37a.45.45,0,0,1-.25-.07.5.5,0,0,1-.19-.68l1.12-1.94a.49.49,0,1,1,.86.49l-1.11,1.95A.5.5,0,0,1,135.73,390.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.62,386.54a.51.51,0,0,1-.47-.32L123,383.34a.5.5,0,1,1,.92-.38l1.17,2.89a.5.5,0,0,1-.28.65A.58.58,0,0,1,124.62,386.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.67,383.76a.43.43,0,0,1-.19,0,.51.51,0,0,1-.27-.65l.83-2a.5.5,0,0,1,.66-.27.51.51,0,0,1,.27.65l-.84,2A.5.5,0,0,1,132.67,383.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,406.31a.48.48,0,0,1-.41-.21.5.5,0,0,1,.12-.7l1.83-1.27a.5.5,0,0,1,.7.12.51.51,0,0,1-.12.7l-1.84,1.27A.41.41,0,0,1,129,406.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.84,397.59a.49.49,0,0,1-.46-.31l-.56-1.39a.5.5,0,0,1,.93-.37l.55,1.39a.5.5,0,0,1-.27.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.92,302.39a.5.5,0,0,1-.44-.27.49.49,0,0,1,.22-.67l1.41-.72a.51.51,0,0,1,.68.21.52.52,0,0,1-.22.68l-1.42.72A.46.46,0,0,1,93.92,302.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.34,325.29a.48.48,0,0,1-.42-.23.5.5,0,0,1,.15-.69l1.32-.82a.49.49,0,0,1,.69.16.51.51,0,0,1-.16.69l-1.32.82A.48.48,0,0,1,108.34,325.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.65,320.24a.48.48,0,0,1-.45-.29.49.49,0,0,1,.25-.66l1.68-.76a.49.49,0,0,1,.66.24.52.52,0,0,1-.25.67l-1.68.76A.52.52,0,0,1,104.65,320.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.77,349.78h-.12l-2.27-.55a.5.5,0,0,1-.37-.6.51.51,0,0,1,.6-.37l2.27.55a.5.5,0,0,1-.11,1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.83,362.74h0l-2.05-.19a.48.48,0,0,1-.45-.54.49.49,0,0,1,.54-.45l2,.18a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.4,399.18A.49.49,0,0,1,138,399a.5.5,0,0,1,.14-.69l1.53-1a.5.5,0,0,1,.69.14.49.49,0,0,1-.14.69l-1.53,1A.46.46,0,0,1,138.4,399.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,312.42l-.12,0a.5.5,0,0,1-.36-.6l.63-2.55a.48.48,0,0,1,.6-.36.5.5,0,0,1,.37.6l-.63,2.55A.51.51,0,0,1,107,312.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,356.82a.49.49,0,0,1-.28-.09.5.5,0,0,1-.14-.69l1-1.45a.5.5,0,0,1,.69-.14.51.51,0,0,1,.14.7l-1,1.45A.52.52,0,0,1,96,356.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,368.39a.5.5,0,0,1-.07-1l3-.46a.5.5,0,1,1,.15,1l-3,.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.19,335.35a.51.51,0,0,1-.36-.15l-1.72-1.78a.5.5,0,0,1,.72-.7l1.72,1.78a.5.5,0,0,1,0,.71A.52.52,0,0,1,141.19,335.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,362.94h0a.5.5,0,0,1-.46-.54l.21-2.65a.51.51,0,0,1,.54-.45.49.49,0,0,1,.46.53l-.21,2.65A.49.49,0,0,1,114,362.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,332a.5.5,0,0,1-.38-.83l1.94-2.18a.5.5,0,0,1,.75.67l-1.94,2.17A.5.5,0,0,1,148.9,332Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.17,346.8a.52.52,0,0,1-.27-.07.51.51,0,0,1-.16-.69l1-1.66a.5.5,0,0,1,.68-.16.5.5,0,0,1,.17.69l-1,1.66A.49.49,0,0,1,136.17,346.8Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.73,340.54a.5.5,0,0,1-.07-1l2.38-.38a.51.51,0,0,1,.57.42.5.5,0,0,1-.41.57l-2.39.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,323.22a.47.47,0,0,1-.32-.12.5.5,0,0,1-.07-.7l1.64-2a.49.49,0,0,1,.7-.06.5.5,0,0,1,.07.7l-1.64,2A.49.49,0,0,1,134.3,323.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.76,375.58a.47.47,0,0,1-.32-.12.5.5,0,0,1-.07-.7l1.95-2.34a.49.49,0,0,1,.7-.06.5.5,0,0,1,.07.7l-2,2.34A.49.49,0,0,1,112.76,375.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,337.47a.5.5,0,0,1-.36-.14.51.51,0,0,1,0-.71l2.16-2.14a.5.5,0,0,1,.7.71l-2.15,2.14A.49.49,0,0,1,131,337.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,334.44a.46.46,0,0,1-.35-.14l-1.06-1.06a.5.5,0,0,1,.71-.71l1,1.06a.5.5,0,0,1,0,.71A.46.46,0,0,1,125,334.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.19,338.87a.49.49,0,0,1-.32-.12l-1.77-1.52a.51.51,0,0,1,0-.71.49.49,0,0,1,.7,0l1.77,1.53a.49.49,0,0,1,0,.7A.47.47,0,0,1,117.19,338.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.43,345a.5.5,0,0,1-.37-.17L123,343.61a.51.51,0,0,1,0-.71.49.49,0,0,1,.7.05l1.09,1.22a.49.49,0,0,1,0,.7A.46.46,0,0,1,124.43,345Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.89,352.33a.5.5,0,0,1-.28-.08L116,350.5a.5.5,0,0,1-.13-.7.49.49,0,0,1,.69-.13l2.59,1.75a.51.51,0,0,1,.13.69A.48.48,0,0,1,118.89,352.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.85,356.44a.5.5,0,0,1-.4-.19l-1.11-1.45a.5.5,0,0,1,.09-.7.51.51,0,0,1,.7.09l1.12,1.45a.51.51,0,0,1-.1.7A.47.47,0,0,1,130.85,356.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1,368.73a.5.5,0,0,1-.32-.88l1.8-1.51a.5.5,0,0,1,.64.76l-1.8,1.51A.47.47,0,0,1,136.1,368.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57,361.22a.48.48,0,0,1-.34-.13l-2.11-1.94a.5.5,0,0,1,.67-.74l2.12,1.94a.5.5,0,0,1,0,.71A.46.46,0,0,1,124.57,361.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.48,365.84a.51.51,0,0,1-.17,0,.5.5,0,0,1-.3-.64l.63-1.71a.5.5,0,0,1,.64-.3.49.49,0,0,1,.29.64l-.62,1.71A.48.48,0,0,1,131.48,365.84Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78,376.3a.5.5,0,0,1-.36-.84l2-2.09a.5.5,0,1,1,.73.69l-2,2.08A.48.48,0,0,1,130.78,376.3Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesert);
export default __webpack_public_path__ + "static/media/desert.4e12e84418fc80bf24824c0fab6d4b31.svg";
export { ForwardRef as ReactComponent };